import { useBeta } from '@/contexts/BetaContext';

export default function BetaBadge({ className = '' }) {
  const { betaMode } = useBeta();
  if (!betaMode) return null;
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-bold tracking-wider bg-[#D4AF37] text-[#0B192C] uppercase ml-2 align-middle ${className}`}
      title="Beta — limited release"
      data-testid="beta-badge"
    >
      Beta
    </span>
  );
}
